import { render, staticRenderFns } from "./PlanEventsModal.vue?vue&type=template&id=c53bd4f4"
import script from "./PlanEventsModal.vue?vue&type=script&lang=js"
export * from "./PlanEventsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports